// Arrastar para reordenar grupos e itens do orçamento (Rafael, 07/10).
//
// A API já grava a posição: o índice no array vira `orcamentoitem.ordem` ao salvar (grupo e
// subitem). Aqui só a regra pura de mover. Algumas linhas têm posição FIXA, que o recálculo
// reimpõe e que, portanto, o arraste não pode desfazer:
//   - grupo Agência sempre no topo (ordenarGruposComAgenciaNoTopo);
//   - FEE Sanofi no topo do seu grupo (ordenarSubitensSanofiComFeeNoTopo);
//   - Imposto NF Access (1945, Chiesi) sempre por último (aplicarRegraServicosAgenciaChiesi).
// Item só se move DENTRO do próprio grupo (trocar de grupo continua sendo pelo select).

export function moverNaLista(lista, de, para) {
    const copia = [...lista];
    const [movido] = copia.splice(de, 1);
    copia.splice(para, 0, movido);
    return copia;
}

// Devolve a lista nova ou null quando o movimento é recusado (linha fixa ou destino na faixa fixa).
export function moverRespeitandoFixos(lista, de, para, { fixoTopo = () => false, fixoFim = () => false } = {}) {
    if (!Array.isArray(lista)) return null;
    if (de === para || de < 0 || para < 0 || de >= lista.length || para >= lista.length) return null;
    const movido = lista[de];
    if (fixoTopo(movido) || fixoFim(movido)) return null;
    const qtdTopo = lista.filter(fixoTopo).length;
    const qtdFim = lista.filter(fixoFim).length;
    if (para < qtdTopo || para > lista.length - 1 - qtdFim) return null;
    return moverNaLista(lista, de, para);
}

// Id estável para o arraste (o mesmo que a key do React usa).
export function idOrdenavel(prefixo, registro, index) {
    const chave = registro && (registro.id ?? registro.chavegrupo ?? registro.chaveunica);
    return prefixo + '-' + (chave !== undefined && chave !== null && chave !== '' ? chave : 'i' + index);
}

// `expandedRows` guarda ÍNDICES de grupo: ao mover um grupo, os índices andam junto.
export function remapearIndice(indice, de, para) {
    if (indice === de) return para;
    if (de < para && indice > de && indice <= para) return indice - 1;
    if (de > para && indice >= para && indice < de) return indice + 1;
    return indice;
}

export function remapearExpandidos(expandidos, de, para) {
    if (!Array.isArray(expandidos)) return expandidos;
    return expandidos.map((i) => remapearIndice(i, de, para));
}
